import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=6da678ed&scoped=true&"
import script from "./SidebarLink.vue?vue&type=script&lang=js&"
export * from "./SidebarLink.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLink.vue?vue&type=style&index=0&id=6da678ed&prod&scoped=true&lang=css&"
import style1 from "./SidebarLink.vue?vue&type=style&index=1&id=6da678ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da678ed",
  null
  
)

export default component.exports